import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=da6d8cec&scoped=true&"
import script from "./StatusLabel.vue?vue&type=script&lang=ts&"
export * from "./StatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=da6d8cec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6d8cec",
  null
  
)

export default component.exports